import VueI18n from 'vue-i18n/dist/vue-i18n';
import Vue from 'vue';
import enTranslation from '@/locales/en.json';
import uaTranslation from '@/locales/ua.json';
import ruTranslation from '@/locales/ru.json';
import roTranslation from '@/locales/ro.json';

Vue.use(VueI18n);

export const LOCALE_KEY = 'lang';

const messages = {
  en: enTranslation,
  uk: uaTranslation,
  ru: ruTranslation,
  ro: roTranslation,
};

const browserLocale = navigator.language.split('-')[0];
const availableLocales = Object.keys(messages);
const savedLocale =
  localStorage.getItem(LOCALE_KEY) ||
  (availableLocales.includes(browserLocale) ? browserLocale : 'en');

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
